import { render, staticRenderFns } from "./entity-card-children-detail-budget-details.vue?vue&type=template&id=d5db6698&"
import script from "./entity-card-children-detail-budget-details.vue?vue&type=script&lang=js&"
export * from "./entity-card-children-detail-budget-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports